export default __webpack_public_path__ + "static/media/textTitleWin.ae235873.png";